// ** Reducers Imports

import authentication from "./authentication";
import inventory from "./inventory";
import candidate from "./candidate";
import jobPosts from "./jobPosts";
import employee from "./employee";
import attendance from "./attendance";
import leave from "./leave";
import cart from "./cartSlice";

const rootReducer = {
  authentication,
  inventory,
  candidate,
  jobPosts,
  employee,
  attendance,
  leave,
  cart,
};

export default rootReducer;
